import React, { memo } from "react";
import searchIcon from "../../assets/searchEvents.svg";

const PLACEHOLDER = "Search events, teams, channels";

const SearchBar = memo(({ query }) => (
    <div className="epgSearchBar">
        <img src={searchIcon} alt="" className="epgSearchBar__icon" />
        {query ? (
            <span className="epgSearchBar__value">
                {query}
                <span className="epgSearchBar__caret" />
            </span>
        ) : (
            <span className="epgSearchBar__placeholder">{PLACEHOLDER}</span>
        )}
    </div>
));

export default SearchBar;
